import React from "react"
import SnailTrail from "../../../SnailTrail"
import {Container, SnailTrailWrapper} from "./component"

interface PrimaryNavProps {
    closeNav: () => void
    mobileHeight: number
    desktopHeight: number
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const PrimaryNav = ({closeNav, mobileHeight, desktopHeight}: PrimaryNavProps) => {
    return (
        <Container data-testid="primary-meganav" mobileHeight={mobileHeight} desktopHeight={desktopHeight}>
            <SnailTrailWrapper onScroll={closeNav} mobileHeight={mobileHeight} desktopHeight={desktopHeight}>
                <SnailTrail />
            </SnailTrailWrapper>
        </Container>
    )
}

export default PrimaryNav
